type WeeklyReportOwnerFields = {
  create_by_user_id?: unknown;
  createByUserId?: unknown;
};

const normalizeIdentity = (value: unknown): string =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

/**
 * 検索条件に合致する週報の閲覧判定専用。保存済み発行者のログインID
 * （メールアドレス）を照合し、表示名・更新者・連名者は利用しない。
 */
export const isAuthenticatedWeeklyReportOwner = (
  report: WeeklyReportOwnerFields | null | undefined,
  authenticatedUserId: unknown
): boolean => {
  const storedAuthorId = normalizeIdentity(
    report?.create_by_user_id ?? report?.createByUserId
  );
  const viewerId = normalizeIdentity(authenticatedUserId);
  return Boolean(storedAuthorId && viewerId && storedAuthorId === viewerId);
};
